import axios from ".";
import { getAuthToken } from "../common/routines/user-operations";
const token = getAuthToken();
export const getDashboard = () => {
    return axios({
      method: "GET",
      url: "/dashboard/metrics",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
};

export const getUpcomingBirthdays = () => {
  return axios({
    method: "GET",
    url: "/dashboard/customers-upcoming-birthdays",
    params:{
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export const getDashboardTaskByDate = (date: any) => {
  return axios({
    method: "GET",
    url: "/dashboard/user-activities",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params:{
      "date": date,
      "timezone":  Intl.DateTimeFormat().resolvedOptions().timeZone,
  }
  });
}
